import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "pdl-10 pdr-10 mt-30" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-20" }, "Member Search", -1)
const _hoisted_3 = { class: "d-flex gap-20 flex-wrap mt-20" }
const _hoisted_4 = { class: "w-100 d-flex gap-20 flex-md-row flex-column" }
const _hoisted_5 = { class: "w-100 d-flex gap-20 flex-md-row flex-column" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-input" }, null, -1)
const _hoisted_7 = { class: "d-flex gap-2 justify-content-between w-100" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between mb-4" }, null, -1)
const _hoisted_9 = {
  class: "small striped toggle no-underline mt-10",
  id: "table-contract-info"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Date of Birth"),
    /*#__PURE__*/_createElementVNode("th", null, "NBF Participant ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Phone No.")
  ])
], -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "large text-center" }
const _hoisted_13 = { colspan: "4" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_18 = { key: 2 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("tr", { class: "large text-center" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "4" }, " No Records found ")
], -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, { error: $setup.error }, null, 8, ["error"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_MessageCard, {
        message: "You can filter your member search by first name, middle name, lastname, SSN and date of birth. To view the Member Profile, click on the name below.",
        type: "primary",
        iconClass: "iatse-icon-alarm",
        classes: "info_card__page"
      }),
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_TextInput, {
            type: "text",
            label: "First Name",
            max: 50,
            placeholder: "Enter FirstName",
            modelValue: $setup.filters.FirstName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.filters.FirstName) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_TextInput, {
            type: "text",
            label: "Middle Name",
            max: 50,
            placeholder: "Enter MiddleName",
            modelValue: $setup.filters.MiddleName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters.MiddleName) = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_TextInput, {
            type: "text",
            label: "Last Name",
            max: 50,
            placeholder: "Enter LastName",
            modelValue: $setup.filters.LastName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters.LastName) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_DateInput, {
            label: "Date of Birth",
            modelValue: $setup.filters.DateofBirth,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters.DateofBirth) = $event)),
            reset: $setup.reset,
            "onUpdate:reset": _cache[4] || (_cache[4] = ($event: any) => (($setup.reset) = $event))
          }, null, 8, ["modelValue", "reset"]),
          _createVNode(_component_TextInput, {
            type: "text",
            name: "number",
            label: "NBF Participant ID or SSN",
            placeholder: "Search by NBF Participant ID or SSN:",
            max: 9,
            modelValue: $setup.filters.ParticipantID,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.filters.ParticipantID) = $event)),
            onInput: $setup.validateParticipantID
          }, null, 8, ["modelValue", "onInput"]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary w-sm-100",
            onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.resetFilters && $setup.resetFilters(...args)), ["prevent"]))
          }, "Reset"),
          _createElementVNode("button", {
            class: "btn btn-primary w-fit w-sm-100",
            onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.searchData && $setup.searchData(...args)), ["prevent"])),
            onKeypress: _cache[8] || (_cache[8] = _withKeys(
//@ts-ignore
(...args) => ($setup.searchData && $setup.searchData(...args)), ["enter"]))
          }, _toDisplayString($setup.loading ? 'Searching...' : 'Search'), 33)
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_8,
        _createElementVNode("table", _hoisted_9, [
          _hoisted_10,
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                _createElementVNode("tr", _hoisted_12, [
                  _createElementVNode("td", _hoisted_13, [
                    _createVNode(_component_LoaderComponent)
                  ])
                ])
              ]))
            : ($setup.membersStore.list?.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.membersStore.list, (person) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: person.PersonID,
                      class: "large"
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("a", {
                          href: "javascript;",
                          class: "plan-modal",
                          onClick: _withModifiers(($event: any) => ($setup.openModal('local-member-profile', 'Member Profile', 'plan-profile plan-tables profile', null, { PersonID: person.PersonID })), ["prevent"])
                        }, _toDisplayString(person.FullName), 9, _hoisted_15)
                      ]),
                      (person.DateofBirth)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString(person.DateofBirth), 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_17, "Missing Info")),
                      _createElementVNode("td", null, _toDisplayString(person.PersonID), 1),
                      _createElementVNode("td", null, _toDisplayString(person.Phone), 1)
                    ]))
                  }), 128))
                ]))
              : (!$setup.membersStore.list?.length)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, _hoisted_20))
                : _createCommentVNode("", true)
        ]),
        _createVNode(_component_PaginationComponent, {
          paginator: $setup.paginator,
          onFetchData: $setup.fetchPaginationData
        }, null, 8, ["paginator", "onFetchData"])
      ])
    ])
  ], 64))
}